import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";

/* =========================
   STYLES
========================= */
const styles = StyleSheet.create({
  page: { padding: 20, fontSize: 9, fontFamily: "Helvetica", paddingTop: 6 },

  header: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 10,
  },

  schoolInfo: { flex: 1, alignItems: "center", marginLeft: -15 },

  table: {
    display: "table",
    width: "auto",
    borderWidth: 1,
    marginTop: 4,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    fontSize: 8,
  },

  tableRow: { flexDirection: "row" },

  tableColHeader: {
    width: "14.28%",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#eeeeee",
    padding: 4,
    fontWeight: "bold",
  },

  tableCol: {
    width: "14.28%",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 4,
  },

  label: { fontWeight: "bold" },

  separator: { borderBottom: "1 solid black", marginVertical: 5 },
  separator2: { borderBottom: "1 solid black", marginVertical: 3 },

  footer: {
    position: "absolute",
    bottom: 10,
    left: 0,
    right: 0,
    textAlign: "center",
    fontSize: 8,
  },
});

/* =========================
   PDF DOCUMENT
========================= */
const AnnexurePDF11 = ({
  modalData,
  modalchallan,
  schoolCode,
  schoolName,
  annexureDateTime,
}) => {
  const totalFees = modalData.reduce(
    (sum, s) => sum + Number(s.exaM_FEES || 0) + Number(s.latE_FEE || 0),
    0
  );

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Generated On */}
        <View style={{ alignSelf: "flex-end", marginBottom: 5 }}>
          <Text style={{ fontSize: 8 }}>
            <Text style={{ fontWeight: "bold" }}>Generated On:</Text>{" "}
            {annexureDateTime}
          </Text>
        </View>

        {/* Header */}
        <View style={styles.header}>
          <Image
            src="../assets/images/jac-academic-council.png"
            style={{ width: 40, height: 40 }}
          />
          <View style={styles.schoolInfo}>
            <Text style={{ fontSize: 12, fontWeight: "bold" }}>
              Jharkhand Academic Council, Ranchi
            </Text>
            <Text style={{ fontSize: 10 }}>
              <Text style={{ fontWeight: "bold" }}>Class XI Annexure -</Text>{" "}
              2026 (Annual)
            </Text>
            <Text style={{ fontSize: 10 }}>
              <Text style={styles.label}>School Code:</Text> {schoolCode}
            </Text>
            <Text style={{ fontSize: 10 }}>
              <Text style={styles.label}>School Name:</Text> {schoolName}
            </Text>
          </View>
        </View>

        <View style={styles.separator} />

        {/* Challan Info */}
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            marginBottom: 4,
          }}
        >
          <Text>
            <Text style={styles.label}>Challan No.:</Text>{" "}
            {modalchallan.challaN_NO}
          </Text>
          <Text>
            <Text style={styles.label}>Challan Generated On:</Text>{" "}
            {modalchallan.challaN_ENTRY_DATE} |{" "}
            {modalchallan.challaN_ENTRY_TIME}
          </Text>
        </View>

        <View style={styles.separator2} />

        {/* Table */}
        <View style={styles.table}>
          <View style={styles.tableRow}>
            <Text style={styles.tableColHeader}>Candidate Name</Text>
            <Text style={styles.tableColHeader}>Gender</Text>
            <Text style={styles.tableColHeader}>Board</Text>
            <Text style={styles.tableColHeader}>Category</Text>
            <Text style={styles.tableColHeader}>Reg. Fees</Text>
            <Text style={styles.tableColHeader}>Late Fees</Text>
            <Text style={styles.tableColHeader}>Total</Text>
          </View>

          {modalData.map((s, i) => (
            <View style={styles.tableRow} key={i}>
              <Text style={styles.tableCol}>{s.candidatE_NAME || ""}</Text>
              <Text style={styles.tableCol}>{s.gender || ""}</Text>
              <Text style={styles.tableCol}>{s.castE_NAME || ""}</Text>
              <Text style={styles.tableCol}>
                {s.studenT_EXAM_SUB_CATEGORY || ""}
              </Text>
              <Text style={styles.tableCol}>
                {Number(s.exaM_FEES || 0).toFixed(2)}
              </Text>
              <Text style={styles.tableCol}>
                {Number(s.latE_FEE || 0).toFixed(2)}
              </Text>
              <Text style={styles.tableCol}>
                {(Number(s.exaM_FEES || 0) + Number(s.latE_FEE || 0)).toFixed(
                  2
                )}
              </Text>
            </View>
          ))}

          {/* Total */}
          <View style={styles.tableRow}>
            <Text style={styles.tableCol}></Text>
            <Text style={styles.tableCol}></Text>
            <Text style={styles.tableCol}></Text>
            <Text style={styles.tableCol}></Text>
            <Text style={styles.tableCol}></Text>
            <Text style={[styles.tableCol, { fontWeight: "bold" }]}>
              Total Fees
            </Text>
            <Text style={[styles.tableCol, { fontWeight: "bold" }]}>
              {totalFees.toFixed(2)}
            </Text>
          </View>
        </View>

        {/* Footer */}
        <Text
          style={styles.footer}
          render={({ pageNumber, totalPages }) =>
            `Page ${pageNumber} of ${totalPages}`
          }
          fixed
        />
      </Page>
    </Document>
  );
};

export default AnnexurePDF11;
